import Graduation from '../events/Graduation';
import BannerInternationalWorkshop from '../events/BannerInternationalWorkshop';
import styled from 'styled-components';

const MainWorkshops = () => {
    const compareDates = (date) => {
        const dateParts = date.split('-');
        const dateObject = new Date(
            dateParts[0],
            dateParts[1] - 1,
            dateParts[2]
        );
        dateObject.setHours(0, 0, 0, 0);

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        return dateObject < today;
    };

    const workshops = [
        {
            title: 'LATAM meets Silicon Valley 2026',
            description: '',
            country: 'Silicon Valley',
            date: '27 al 30 de Mayo, 2026',
            id: 5,
            img: './assets/internationalWorkshop/Workshop-SV.png',
            description_complete: '',
            link: 'https://www.aden.org/workshop-silicon-valley/',
            untilDate: 'Miércoles 20 de Mayo',
            briefing: 'Lunes 27 de Abril',
            disabled: compareDates('2026-05-20'),
            pdf: 'https://drive.google.com/file/d/1JConnrNmIzRJvd65K9fdkNJL4FKAOFRW/view?usp=sharing',
            // location: 'Hotel Pullman Miami Airport',
        },
        {
            title: 'Innovación, Tecnología y Tendencias',
            description: '',
            country: 'Miami',
            date: '18 al 20 de noviembre 2026',
            id: 3,
            img: './assets/internationalWorkshop/nuevas-tecnologias.png',
            description_complete: '',
            link: 'https://www.aden.org/programa/workshop-miami/',
            // untilDate: 'Lunes 3 de Noviembre',
            // briefing: 'Miércoles 01 de Octubre',
            disabled: compareDates('2026-11-03'),
            // pdf: 'https://drive.google.com/file/d/1o26dT_QdNRBPt38wOdO6M3nYCLK8AlXN/view?usp=sharing',
            // location: 'Hotel Pullman Miami Airport',
        },
        {
            title: 'Workshop Washington',
            description: '',
            country: 'Washington',
            date: '7 al 9 de octubre de 2026',
            id: 4,
            img: './assets/internationalWorkshop/washington-ws.png',
            description_complete: '',
            link: 'https://www.aden.org/programa/workshop-washington/',
            // untilDate: 'Miércoles 1 de Octubre',
            // briefing: 'Lunes 22 de Septiembre',
            disabled: compareDates('2026-10-01'),
            // pdf: 'https://drive.google.com/file/d/1AwTkPfRjwIJyeJeeFsmhE8mhSeHu_gVq/view?usp=sharing',
            // location: 'Hotel Pullman Miami Airport',
        },
        {
            title: 'El impacto de la IA',
            description: '',
            country: 'Barcelona',
            date: '8 al 10 de septiembre 2026',
            id: 6,
            img: './assets/internationalWorkshop/innovacion.png',
            description_complete: '',
            link: 'https://www.aden.org/programa/workshop-barcelona/',
            // untilDate: 'Viernes 29 de Agosto',
            // briefing: 'Jueves 14 de Agosto',
            disabled: compareDates('2026-08-30'),
            // pdf: 'https://drive.google.com/file/d/17JfGGQOHfqfz6Svg6LbNf_U8q4_JHn-F/view?usp=sharing',
            // location: 'C/ de Rosselló i Pòrcel, 7-11',
        },
    ];

    return (
        <Container>
            <WrapperWorkshop>
                <WrapperCard>
                    <BannerInternationalWorkshop />
                    <Container>
                        <Graduation workshops={workshops} />
                    </Container>
                </WrapperCard>
            </WrapperWorkshop>
        </Container>
    );
};

const WrapperWorkshop = styled.div`
    display: flex;
    padding-top: 20px;
    padding-bottom: 4rem;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    gap: 3rem;
    height: 100%;
`;

const WrapperCard = styled.div`
    width: calc(100% - 48px);
    box-shadow:
        0px 12px 24px -15px #0000001a,
        0px 0px 10px -6px #00000040;
    border-radius: 20px;
    padding: 24px;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 48px;
    background-color: #fff;
`;
const Container = styled.div`
    display: flex;
    overflow: hidden;
    border-radius: 20px;
    flex-direction: column;
    row-gap: 2rem;
`;

export default MainWorkshops;
